(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-hero"]) return;
  try {
    
class AboutHero extends HTMLElement {
    connectedCallback() {
        this.bg = this.querySelector('.js-bg img')

        gsap.to(this.bg, {
            scale: 1,
            ease: 'power2.inOut',
            duration: 1.4,
            scrollTrigger: {
                trigger: this.bg
            }
        })
        gsap.to(this.bg, {
            yPercent: 20,
            scrollTrigger: {
                trigger: this.wrapper,
                scrub: true,
                start: "top top",
                end: "bottom top",
            }
        })
    }
}
customElements.define('about-hero', AboutHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  class AppFooter extends HTMLElement {
    connectedCallback() {

      // animated back to top function
      this.querySelector('.backToTop').addEventListener('click', (e) => {
        e.preventDefault();
        const progress = {y:window.pageYOffset}
        gsap.to(progress, {
          y:0,
          duration:1,
          ease:'power4.inOut',
          onUpdate:() => { window.scrollTo(0, progress.y) }
        })
      })


      this.visuals = this.querySelector('.js-footer-visual')
      this.counter = 0;
      this.incCounter = this.incCounter.bind(this)

      const interval = gsap.set(this.incCounter, {
        onRepeat: this.incCounter,
        repeat: -1,
        repeatDelay: 1.8,
        paused: true
      });

      ScrollTrigger.create({
        trigger: this.visuals,
        start: "top 80%",
        end: "bottom top",
        onEnter: () => {
          interval.play()
        },
        onEnterBack: () => {
          interval.play()
        },
        onLeave: () => {
          interval.pause()
        },
        onLeaveBack: () => {
          interval.pause()
        },
      });
    }

    incCounter() {
      this.visuals.children[this.counter].classList.remove('-active')
      this.counter++;
      if(this.counter === this.visuals.children.length) this.counter = 0
      this.visuals.children[this.counter].classList.add('-active')
    }
  }

  customElements.define('app-footer', AppFooter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.mobileLines = document.querySelector('.mobile-lines');

      requestAnimationFrame(() => { requestAnimationFrame(() => {
        gsap.to(this.mobileLines, {
          scrollTrigger: {
            trigger: this.mobileLines,
            // start: 'top 60px',
            end: 'bottom top',
            onEnter: () => {
              this.mobileLines.classList.add('-active')
            },
            onEnterBack: () => {
              this.mobileLines.classList.add('-active')
            },
            onLeave: () => {
              this.mobileLines.classList.remove('-active')
            },
            onLeaveBack: () => {
              this.mobileLines.classList.remove('-active')
            },
          }
        })
      }); });

      this.form = document.querySelector('#LanguageForm')
      this.formInput = this.form.querySelector('input[name="locale_code"]')
      this.langSwitchers = Array.from(document.querySelectorAll('.js-lang-switcher'))

      this.langSwitchers.forEach(l => l.addEventListener('click', this.switchLang.bind(this)))

      // this.header = document.getElementById('shopify-section-header');
      // this.headerBounds = {};
      // this.currentScrollTop = 0;
      // this.preventReveal = false;
      // this.predictiveSearch = this.querySelector('predictive-search');

      // this.onScrollHandler = this.onScroll.bind(this);
      // this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      // this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      // window.addEventListener('scroll', this.onScrollHandler, false);

      // this.createObserver();
    }

    switchLang(e) {
      e.preventDefault()
      this.formInput.value = e.currentTarget.dataset.value
      this.form.submit()
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (window.innerWidth >= 1024 || (this.predictiveSearch && this.predictiveSearch.isOpen)) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-collections"]) return;
  try {
    
class HomeCollections extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
        this.activeIndex = 0
        this.swiperVisualEl = this.querySelector('.js-swiper-visual')
        this.swiperDetailsEl = this.querySelector('.js-swiper-details')
        this.swiperMobileEl = this.querySelector('.js-swiper-mobile')

        this.productsWrapper = this.querySelector('.js-productsWrapper')
        this.productsLines = Array.from(this.querySelectorAll('.js-productsLine'))

        requestAnimationFrame(() => { requestAnimationFrame(() => { this.initAnimations(); }); });
    }

    initAnimations() {
        const mm = gsap.matchMedia()
        mm.add("(min-width: 1024px)", () => {
            this.swiperDetails = new Swiper(this.swiperDetailsEl, {
                speed: 600,
                effect: "fade",
                allowTouchMove: false
            })
            const links = this.swiperDetails.slides.map(s => {
                return Array.from(s.querySelectorAll('a'))
            })
            for(let i = 1; i < this.swiperDetails.slides.length; i++) {
                links[i].forEach(l => l.setAttribute('tabindex', -1))
            }

            this.swiperVisual = new Swiper(this.swiperVisualEl, {
                navigation: {
                    nextEl: '.next-btn',
                    prevEl: '.prev-btn',
                },
                speed: 600,
                // effect: "fade",
                grabCursor: true,
                controller: {
                    control: this.swiperDetails
                }
            })
            this.swiperVisual.on('slideChange', () => {
                this.productsLines[this.activeIndex].classList.remove('-active')
                links[this.activeIndex].forEach(l => l.setAttribute('tabindex', -1))

                this.activeIndex = this.swiperVisual.activeIndex
                this.productsLines[this.activeIndex].classList.add('-active')

                links[this.activeIndex].forEach(l => l.removeAttribute('tabindex'))
            })

            this.stDesktop = gsap.to(this.productsWrapper, {
                xPercent: -100 * 3/4,
                scrollTrigger: {
                    trigger: this.productsWrapper,
                    scrub: 2,
                    start: 'top 70%',
                    end: 'bottom 30%',
                    // markers: true
                }
            })

            return () => {
                this.swiperDetails.destroy(true, false)
                this.swiperVisual.destroy(true, false)
                this.stDesktop.scrollTrigger.kill()
                this.stDesktop.kill()
            }
        })
        mm.add("(max-width: 1023px)", () => {
            this.swiperMobile = new Swiper(this.swiperMobileEl, {
                navigation: {
                    nextEl: '.next-btn-mobile',
                    prevEl: '.prev-btn-mobile',
                },
                speed: 600,
                autoHeight: true
            })
            const links = this.swiperMobile.slides.map(s => {
                return Array.from(s.querySelectorAll('a'))
            })
            for(let i = 1; i < this.swiperMobile.slides.length; i++) {
                links[i].forEach(l => l.setAttribute('tabindex', -1))
            }
            this.swiperMobile.on('slideChange', () => {
                links[this.activeIndex].forEach(l => l.setAttribute('tabindex', -1))
                this.activeIndex = this.swiperMobile.activeIndex
                links[this.activeIndex].forEach(l => l.removeAttribute('tabindex'))
            })
        })

    }
}

customElements.define('home-collections', HomeCollections);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"]) return;
  try {
    
  class HomeHero extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.wrapper = this.querySelector('.js-homeHero-wrapper');
      this.tagline = this.querySelector('.js-homeHero-tagline');
      this.btn = this.querySelector('.js-homeHero-btn');
      this.btnWrapper = this.querySelector('.js-homeHero-btnWrapper');
      this.desc = this.querySelector('.js-homeHero-desc');
      this.imgs = this.querySelectorAll('.js-homeHero-img');
      //   this.imgFront = this.querySelector('.js-homeHero-img-front');
      requestAnimationFrame(() => { requestAnimationFrame(() => { this.initAnimations(); }); });
    }

    initAnimations() {
      const mm = gsap.matchMedia();
      mm.add('(min-width: 1024px) and (orientation: landscape)', () => {
        gsap.set([this.btn, this.desc], { y: 40, opacity: 0 });

        gsap.to(this.imgs, {
          scale: 1,
          ease: 'power2.inOut',
          duration: 1.4,
          scrollTrigger: {
            trigger: this.imgs[0],
          },
        });

        gsap.to(this.btn, {
          y: 0,
          opacity: 1,
          ease: 'power2.out',
          duration: 0.6,
          delay: 1,
          scrollTrigger: {
            trigger: this.btn,
          },
        });

        gsap.to(this.imgs[0], {
          yPercent: 25,
          scrollTrigger: {
            trigger: this.wrapper,
            scrub: true,
            start: 'top top',
            end: 'bottom top',
            // markers: true,
          },
        });
        // gsap.to(this.imgFront, {
        //   yPercent: 20,
        //   scrollTrigger: {
        //     trigger: this.wrapper,
        //     scrub: true,
        //     start: 'top top',
        //     end: 'bottom top',
        //     // markers: true,
        //   },
        // });
        gsap.to(this.btnWrapper, {
          scale: 1,
          scrollTrigger: {
            trigger: this.wrapper,
            pin: this.btnWrapper,
            scrub: 1,
            start: 'top top',
            // end: () => `+=${
            //     window.scrollY + this.desc.getBoundingClientRect().bottom +
            //     this.desc.offsetHeight + this.btn.offsetHeight + 20
            //     - window.innerHeight
            // }`,
            end: () =>
              `+=${
                this.desc.getBoundingClientRect().bottom -
                this.btn.getBoundingClientRect().bottom +
                this.desc.offsetHeight -
                20
              }`,
            invalidateOnRefresh: true,
            // markers: true,
          },
        });
        gsap.to(this.desc, {
          y: 0,
          opacity: 1,
          ease: 'power2.out',
          duration: 0.6,
          scrollTrigger: {
            trigger: this.desc,
            start: 'start 80%',
            // markers: true
          },
        });
      });
      mm.add('(max-width: 1023px)', () => {
        gsap.to(this.imgs, {
          scale: 1,
          ease: 'power2.inOut',
          duration: 1.4,
          scrollTrigger: {
            trigger: this.imgs[0],
          },
        });

        gsap.to(this.imgs[0], {
          yPercent: 20,
          scrollTrigger: {
            trigger: this.wrapper,
            scrub: true,
            start: 'top top',
            end: 'bottom top',
            // markers: true,
          },
        });
        gsap.to(this.imgs[0], {
          yPercent: 10,
          scrollTrigger: {
            trigger: this.wrapper,
            scrub: true,
            start: 'top top',
            end: 'bottom top',
            // markers: true,
          },
        });
      });
    }
  }

  customElements.define('home-hero', HomeHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  class CollectionHero extends HTMLElement {
    connectedCallback() {
      this.sortDetails = this.querySelector('#details-collection-sort')
      this.sortSelect = this.querySelector('select')
      this.sortForm = this.querySelector('#FacetFiltersForm')
      this.sortCurrent = this.querySelector('.current_sort')
      this.sortButtons = Array.from(this.sortDetails.querySelectorAll('button'))
      this.sortActive = this.sortButtons.find(btn => btn.classList.contains('-active'))

      this.grid = document.querySelector('#product-grid')

      this.sortButtons.forEach(btn => btn.addEventListener('click', this.onBtnClick.bind(this)))
    }

    onBtnClick(e) {
      const { value, name } = e.target.dataset
      this.sortSelect.value = value
      this.sortForm.dispatchEvent(new Event('input'));
      this.sortDetails.removeAttribute('open')

      this.sortActive.classList.remove('-active')
      this.sortCurrent.innerText = name
      this.sortActive = e.target
      this.sortActive.classList.add('-active')

      this.grid.scrollIntoView({
        behavior: 'smooth'
      })
    }
  }

  customElements.define('collection-hero', CollectionHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-long-description"]) return;
  try {
    
  class ProductBar extends HTMLElement {
    connectedCallback() {
      this.originalVariantSelect = document.querySelector('.productHero__variantSelect select');
      this.originalQuantityInput = document.querySelector('.productHero__quantity input');
      this.originalPrice = document.querySelector('.productHero .price');
      this.originalIdInput = document.querySelector('.productHero input[name="id"]');

      this.variantSelect = this.querySelector('.productHero__variantSelect select');
      this.quantityInput = this.querySelector('.productHero__quantity input');
      this.price = this.querySelector('.price');
      this.idInput = this.querySelector('input[name="id"]');

      // sync inputs
      if (this.originalVariantSelect) {
        this.originalVariantSelect.addEventListener('change', () => {
          this.variantSelect.value = this.originalVariantSelect.value;
        });
        this.variantSelect.addEventListener('change', () => {
          this.originalVariantSelect.value = this.variantSelect.value;
        });
      }

      if (this.originalQuantityInput) {
        this.originalQuantityInput.addEventListener('change', () => {
          this.quantityInput.value = +this.originalQuantityInput.value;
        });
        this.quantityInput.addEventListener('change', () => {
          this.originalQuantityInput.value = +this.quantityInput.value;
        });
      }
      this.originalIdInput.addEventListener('change', () => {
        this.idInput.value = this.originalIdInput.value;
      });

      this.observer = new MutationObserver(() => {
        this.price.innerHTML = this.originalPrice.innerHTML;
      });
      this.observer.observe(this.originalPrice, { childList: true, subtree: true });

      const mm = gsap.matchMedia()
        mm.add("(min-width: 1280px)", () => {
          ScrollTrigger.create({
            trigger: '.productHero',
            // start: 'bottom top',
            start: 'bottom 80%',
            endTrigger: '.footer',
            end: 'top bottom',
            invalidateOnRefresh: true,
            toggleClass: {
              targets: this,
              className: '-active',
            },
          });
        })

    }
  }

  customElements.define('product-bar', ProductBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductBar extends HTMLElement {
    connectedCallback() {
      this.originalVariantSelect = document.querySelector('.productHero__variantSelect select');
      this.originalQuantityInput = document.querySelector('.productHero__quantity input');
      this.originalPrice = document.querySelector('.productHero .price');
      this.originalIdInput = document.querySelector('.productHero input[name="id"]');

      this.variantSelect = this.querySelector('.productHero__variantSelect select');
      this.quantityInput = this.querySelector('.productHero__quantity input');
      this.price = this.querySelector('.price');
      this.idInput = this.querySelector('input[name="id"]');

      // sync inputs
      if (this.originalVariantSelect) {
        this.originalVariantSelect.addEventListener('change', () => {
          this.variantSelect.value = this.originalVariantSelect.value;
        });
        this.variantSelect.addEventListener('change', () => {
          this.originalVariantSelect.value = this.variantSelect.value;
        });
      }

      if (this.originalQuantityInput) {
        this.originalQuantityInput.addEventListener('change', () => {
          this.quantityInput.value = +this.originalQuantityInput.value;
        });
        this.quantityInput.addEventListener('change', () => {
          this.originalQuantityInput.value = +this.quantityInput.value;
        });
      }
      this.originalIdInput.addEventListener('change', () => {
        this.idInput.value = this.originalIdInput.value;
      });

      this.observer = new MutationObserver(() => {
        this.price.innerHTML = this.originalPrice.innerHTML;
      });
      this.observer.observe(this.originalPrice, { childList: true, subtree: true });

      const mm = gsap.matchMedia()
        mm.add("(min-width: 1280px)", () => {
          ScrollTrigger.create({
            trigger: '.productHero',
            // start: 'bottom top',
            start: 'bottom 80%',
            endTrigger: '.footer',
            end: 'top bottom',
            invalidateOnRefresh: true,
            toggleClass: {
              targets: this,
              className: '-active',
            },
          });
        })

    }
  }

  customElements.define('product-bar', ProductBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-producer"]) return;
  try {
    
  class ProductProducers extends HTMLElement {
    connectedCallback() {
      this.links = Array.from(this.querySelectorAll('li a'));

      if (this.links.length > 1) {
        this.init();
      }
    }

    init() {
      this.visuals = this.querySelector('.js-visual');
      this.counter = 0;
      this.incCounter = this.incCounter.bind(this);
      this.onMouseEnter = this.onMouseEnter.bind(this);
      this.onMouseLeave = this.onMouseLeave.bind(this);
      this.links.forEach((link) => {
        link.addEventListener('mouseenter', this.onMouseEnter);
        link.addEventListener('mouseleave', this.onMouseLeave);
      });

      this.interval = gsap.set(this.incCounter, {
        onRepeat: this.incCounter,
        repeat: -1,
        repeatDelay: 1.8,
        paused: true,
      });

      ScrollTrigger.create({
        trigger: this,
        start: 'top 50%',
        end: 'bottom 50%',
        onEnter: () => {
          this.interval.play();
        },
        onEnterBack: () => {
          this.interval.play();
        },
        onLeave: () => {
          this.interval.pause();
        },
        onLeaveBack: () => {
          this.interval.pause();
        },
      });
    }

    incCounter() {
      this.visuals.children[this.counter].classList.remove('-active');
      this.counter++;
      if (this.counter === this.visuals.children.length) this.counter = 0;
      this.visuals.children[this.counter].classList.add('-active');
    }

    onMouseEnter(e) {
      const { index } = e.target.dataset;
      this.interval.pause();

      this.visuals.children[this.counter].classList.remove('-active');
      this.counter = parseFloat(index);
      this.visuals.children[this.counter].classList.add('-active');
    }

    onMouseLeave() {
      this.interval.play();
    }
  }

  customElements.define('product-producers', ProductProducers);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // fetch(this.dataset.url)
      //     .then(response => response.text())
      //     .then(text => {
      //       const html = document.createElement('div');
      //       html.innerHTML = text;
      //       const recommendations = html.querySelector('product-recommendations');

      //       if (recommendations && recommendations.innerHTML.trim().length) {
      //         this.innerHTML = recommendations.innerHTML;
      //       }

      //       if (html.querySelector('.grid__item')) {
      //         this.classList.add('product-recommendations--loaded');
      //       }

      //       this.createSwiper()
      //       ScrollTrigger.refresh()
      //     })
      //     .catch(e => {
      //       console.error(e);
      //     });
      this.createSwiper()
    }

    createSwiper() {
      this.swiperEl = this.querySelector('.js-swiper')
      this.swiper = new Swiper(this.swiperEl, {
        speed: 600,
        slidesPerView: 1,
        spaceBetween: 15,
        grabCursor: true,
        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 20,
          }
        },
        navigation: {
          nextEl: '.next-btn, .next-btn-mobile',
          prevEl: '.prev-btn, .prev-btn-mobile',
        },
      })
      // TODO: taindex -1 for inactive slides

      // const links = this.swiper.slides.map(s => {
      //     return Array.from(s.querySelectorAll('a'))
      // })
      // for(let i = 1; i < this.swiper.slides.length; i++) {
      //     links[i].forEach(l => l.setAttribute('tabindex', -1))
      // }
      // this.swiperVisual.on('slideChange', () => {
      //     links[this.activeIndex].forEach(l => l.setAttribute('tabindex', -1))

      //     this.activeIndex = this.swiperVisual.activeIndex
      //     this.productsLines[this.activeIndex].classList.add('-active')

      //     links[this.activeIndex].forEach(l => l.removeAttribute('tabindex'))
      // })

    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
